module.exports = __webpack_public_path__ + "static/media/tz.ec5a26d3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tz.svg
// module id = 969
// module chunks = 0